import React, { Component } from "react";
import DayPicker from "react-day-picker";
import { FadeAnimation } from "../../../BookingPortal/components/Shared/Animation";
import { compareDateWithToday } from "./DatePickerHelper";
import "../../../../assets/less/components/customCalendar.less";

const firstYear = new Date(1900);
const fromDate = new Date(firstYear, 0);
const toDate = new Date();
const YearMonthForm = ({ date, localeUtils, onChange }) => {
  const months = localeUtils.getMonths();

  const years = [];
  for (let i = fromDate.getFullYear(); i <= toDate.getFullYear(); i++) {
    years.push(i);
  }

  const handleChange = function handleChange(e) {
    const { year, month } = e.target.form;
    onChange(new Date(year.value, month.value));
  };

  return (
    <form className="DayPicker-Caption">
      <select name="month" onChange={handleChange} value={date.getMonth()}>
        {months.map((month, i) => (
          <option key={month} value={i}>
            {month}
          </option>
        ))}
      </select>
      <select name="year" onChange={handleChange} value={date.getFullYear()}>
        {years.map(year => (
          <option key={year} value={year}>
            {year}
          </option>
        ))}
      </select>
    </form>
  );
};

class DatePickerCalendar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      month: toDate,
      selectedDay: undefined
    };
  }

  componentDidMount = () => {
    if (this.props.value !== undefined) {
      this.setState({
        selectedDay: this.props.value,
        month: this.props.value
      });
    }
  };

  componentWillUpdate = (nextProps, nextState) => {
    if (this.props.value !== nextProps.value) {
      if (nextProps.value === undefined) {
        if (nextState.selectedDay !== undefined) {
          this.setState({
            selectedDay: nextProps.value
          });
        }
      } else {
        if (nextState.selectedDay !== nextProps.value) {
          this.setState({
            selectedDay: nextProps.value,
            month: nextProps.value
          });
        }
      }
    }
  };

  handleYearMonthChange = month => {
    this.setState({ month });
  };

  handleDayClick = (day, { selected }) => {
    if (compareDateWithToday(day)) {
      this.setState({
        selectedDay: selected ? undefined : day
      });
      if (!selected) {
        this.props.onSeletedDay(day);
      }
      this.props.hideAfterDayClick();
    }
  };

  renderDay = day => {
    const date = day.getDate();
    return <span>{date}</span>;
  };

  render() {
    return (
      <FadeAnimation>
        <DayPicker
          className="client-portal-calendar input-date-picker"
          selectedDays={this.state.selectedDay}
          onDayClick={this.handleDayClick}
          month={this.state.month}
          fromMonth={fromDate}
          toMonth={toDate}
          renderDay={this.renderDay}
          disabledDays={[{ after: new Date() }]}
          captionElement={({ date, localeUtils }) => {
            return (
              <YearMonthForm
                date={date}
                localeUtils={localeUtils}
                onChange={this.handleYearMonthChange}
              />
            );
          }}
        />
      </FadeAnimation>
    );
  }
}

export { DatePickerCalendar };



// WEBPACK FOOTER //
// ./src/modules/ContactForm/components/DatePicker/DatePickerCalendar.js